// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3hYZU","rootCenter":"LoadMoreObserver_rootCenter__pDVaH","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__tsl-w"};